// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__34gG9","title":"style_title__1HebS","subtitle":"style_subtitle__3T6fJ"};